// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TextArea, Form } from 'informed';
import moment from 'moment';

import { updateAccount, updatePassword, UPDATE_ACCOUNT_ERROR } from '../../actions/accountActions';

import {
  Label, Success, Error, PrimaryText,
} from '../Typography.jsx';
import { Button, PrimaryButton } from '../Buttons.jsx';
import RequiredText from '../RequiredText.jsx';

import styles from '../../styles/accountPages/AccountPage.scss';

type Props = {
  activeAccount: Object,
  accountUpdated: boolean,
  accountError: string,
  updateAccount: Function,
  updatePassword: Function,
  passwordMismatch: Function,
}

type State = {
  editInfo: boolean,
  changePassword: boolean,
}

class ActiveAccountComponent extends Component<Props, State> {
  infoFormApi: {
    getState: Function,
  }

  passwordFormApi: {
    getState: Function,
    getValue: Function,
    setError: Function,
  }

  constructor(props: Props) {
    super(props);
    this.state = {
      editInfo: false,
      changePassword: false,
    };
  }

  setInfoFormApi = (formApi: Object) => {
    this.infoFormApi = formApi;
  }

  setPasswordFormApi = (formApi: Object) => {
    this.passwordFormApi = formApi;
  }

  submitInfoUpdate = () => {
    const state = this.infoFormApi.getState();
    if (state.invalid) {
      return;
    }
    this.props.updateAccount(this.props.activeAccount._id, state.values);
    this.setState({
      editInfo: false,
    });
  }

  submitPasswordChange = () => {
    const state = this.passwordFormApi.getState();
    if (state.invalid) {
      return;
    }
    if (!this.passwordFormApi.getValue('currPassword')) {
      this.passwordFormApi.setError('currPassword', 'Error');
      return;
    }
    if (!this.passwordFormApi.getValue('newPassword')) {
      this.passwordFormApi.setError('newPassword', 'Error');
      return;
    }
    if (!this.passwordFormApi.getValue('confirmNewPassword')) {
      this.passwordFormApi.setError('confirmNewPassword', 'Error');
      return;
    }
    if (this.passwordFormApi.getValue('newPassword') !== this.passwordFormApi.getValue('confirmNewPassword')) {
      this.props.passwordMismatch();
      return;
    }
    this.props.updatePassword(this.props.activeAccount._id, state.values);
    this.setState({
      changePassword: false,
    });
  }

  editInfo = () => {
    this.setState({
      editInfo: true,
    });
  }

  changePassword = () => {
    this.setState({
      changePassword: true,
    });
  }

  cancel = () => {
    this.setState({
      editInfo: false,
      changePassword: false,
    });
  }

  render() {
    const activeAccount = this.props.activeAccount || {};
    const { editors, editDates } = activeAccount;
    const { editInfo, changePassword } = this.state;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <div>
        <Success>{this.props.accountUpdated && 'Information Updated'}</Success>
        <Error>{this.props.accountError}</Error>
        <Form getApi={this.setInfoFormApi} autoComplete='off'>
          <table>
            <tbody>
              <tr>
                <td><Label>Username: </Label></td>
                <td>{activeAccount.username}</td>
              </tr>
              <tr>
                <td><Label>Name: </Label></td>
                <td>{editInfo
                  ? <RequiredText field='name' initialValue={activeAccount.name} />
                  : activeAccount.name}</td>
              </tr>
              <tr>
                <td><Label>Credential: </Label></td>
                <td>{editInfo
                  ? <RequiredText field='credential' initialValue={activeAccount.credential} />
                  : activeAccount.credential}</td>
              </tr>
              <tr>
                <td><Label>Institution: </Label></td>
                <td>{editInfo
                  ? <RequiredText field='institution' initialValue={activeAccount.institution} />
                  : activeAccount.institution}</td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Notes: </Label></td>
                <td>{editInfo
                  ? <TextArea field='notes' initialValue={activeAccount.notes} />
                  : activeAccount.notes || '--'}</td>
              </tr>
              <tr className={styles.topAlign}>
                <td><Label>Edit History: </Label></td>
                <td>{editHistory || '--'}</td>
              </tr>
            </tbody>
          </table>
        </Form>
        {changePassword
          && <Form getApi={this.setPasswordFormApi} autoComplete='off'>
            <PrimaryText>Change Password</PrimaryText>
            <table>
              <tbody>
                <tr><td>Current Password: </td><td><RequiredText field='currPassword' type='password' /></td></tr>
                <tr><td>New Password: </td><td><RequiredText field='newPassword' type='password' /></td></tr>
                <tr><td>Confirm New Password: </td><td><RequiredText field='confirmNewPassword' type='password' /></td></tr>
              </tbody>
            </table>
          </Form>
        }
        {editInfo
          ? <div>
            <PrimaryButton onClick={this.submitInfoUpdate}>Save</PrimaryButton>
            <Button onClick={this.cancel}>Cancel</Button>
          </div>
          : changePassword
            ? <div>
              <PrimaryButton onClick={this.submitPasswordChange}>Save</PrimaryButton>
              <Button onClick={this.cancel}>Cancel</Button>
            </div>
            : <div>
              <PrimaryButton onClick={this.editInfo}>Edit Information</PrimaryButton>
              <PrimaryButton onClick={this.changePassword}>Change Password</PrimaryButton>
            </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  activeAccount: state.account.activeAccount,
  accountUpdated: state.account.accountUpdated,
  accountError: state.account.accountError,
});

const mapDispatchToProps = dispatch => ({
  updateAccount: (accountId, accountInfo) => dispatch(updateAccount(accountId, accountInfo)),
  updatePassword: (accountId, passwordInfo) => dispatch(updatePassword(accountId, passwordInfo)),
  // fire an action to display sign up error client side, instead of sending confirmPassword server side
  passwordMismatch: () => dispatch({
    type: UPDATE_ACCOUNT_ERROR,
    error: 'New passwords do not match',
  }),
});

const ActiveAccount = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActiveAccountComponent);

export default ActiveAccount;



// WEBPACK FOOTER //
// ./client/src/components/accountPages/ActiveAccount.jsx